import { gql } from '@apollo/client'

const ELIGIBLE_PERSON_FIELDS = gql`
  fragment EligiblePersonFields on EligiblePerson {
    id
    firstName
    lastName
    emailAddress
    magicLink
    enrollment {
      accessToken
      cmsRiderLink
      enrollmentEvents {
        id
        action
        eventDate
        partnerName
      }
    }
    currentEligibility {
      effectiveDate
      terminationDate
    }
    eligibilityPeriods {
      id
      effectiveDate
      terminationDate
    }
    sponsor {
      name
    }
    partner {
      id
      name
    }
  }
`

export { ELIGIBLE_PERSON_FIELDS }
